// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__L8yxL","right":"Footer_right__frcUn","buttons":"Footer_buttons__39jr6"};